import {forwardRef} from 'react';

const Icon = ({ariaLabel, className, width, height, viewBox, children, alt, fill, onClick, ...rest}, ref) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            viewBox={viewBox || `0 0 ${width} ${height}`}
            className={className}
            aria-label={ariaLabel}
            alt={alt}
            ref={ref}
            fill={fill}
            onClick={onClick}
            {...rest}
        >
            {children}
        </svg>
    );
};

export default forwardRef(Icon);
